import $ from 'cash-dom';

let instance = null;

class CallButtonAnimationHandler {
	constructor() {
		if (instance) {
			return instance;
		}

		instance = this;
	}


	/**
	 * @return {CallButtonAnimationHandler}
	 */
	static getInstance() {
		if (!instance) {
			instance = new CallButtonAnimationHandler();
		}

		return instance;
	}

	init() {
		const $buttons = $('.animated-mobile-phone-btn');

		if (!$buttons.length) {
			return;
		}

		if (!('IntersectionObserver' in window)) {
			$buttons.addClass('active');
			return;
		}

		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				$(entry.target).addClass('active');
				obs.unobserve(entry.target);
			});
		}, {
			threshold: 0.6,
		});

		$buttons.each((i, el) => observer.observe(el));
	}
}

export default CallButtonAnimationHandler;
